import Vue from "vue";
import VueRouter from "vue-router";
import reference from "./reference";
import division from "./division.js";
import omtk from "./omtk.js";
import ozl from "./ozl.js";
import history from "./history";
import realization from "./realization";
import BaseLayout from "../layouts/Base";
import store from "@/store";
import { PERMISSIONS } from "@/utils/constants";
import team from "./team";
import authMiddleware from "@/router/middlewares/authMiddleware";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";
import loggedInMiddleware from "@/router/middlewares/loggedInMiddleware";
import redirectToHomeMiddleware from "@/router/middlewares/redirectToHomeMiddleware.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: () => import("../layouts/NewAuthorizationLayout.vue"),
    meta: {
      middleware: [loggedInMiddleware],
    },
    children: [
      {
        path: "/",
        name: "login",
        component: () => import("../pages/auth/login.vue"),
        meta: {
          middleware: [loggedInMiddleware],
        },
      },
      {
        path: "/auth/forbidden",
        name: "forbidden",
        component: () => import("../pages/auth/forbidden.vue"),
      },
    ],
  },
  // {
  //   path: "/settings",
  //   name: "settings",
  //   component: () => import("../pages/admin/settings/index.vue"),
  //   meta: {
  //     middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.USER)],
  //   },
  // },
  {
    path: "",
    component: () => import("../layouts/MainLayout.vue"),
    children: [
      {
        path: "/",
        name: "index",
        meta: {
          middleware: [authMiddleware, redirectToHomeMiddleware],
        },
      },
      {
        path: "/divisions",
        component: BaseLayout,
        children: [...division],
      },
      ...reference,
      ...omtk,
      ...ozl,
      ...realization,
      ...history,
      ...team,
      {
        path: "/users",
        name: "users",
        component: () => import("../pages/admin/user/index"),
        meta: {
          middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.USER)],
        },
      },
      {
        path: "/inventories",
        name: "inventories-index",
        component: () => import("../pages/admin/inventory/index"),
        meta: {
          middleware: [
            authMiddleware,
            permissionMiddleware(PERMISSIONS.INVENTORY),
          ],
        },
      },
      {
        path: "/inventories/:id",
        name: "inventories-item",
        props: true,
        component: () => import("../pages/admin/inventory/item"),
        meta: {
          middleware: [
            authMiddleware,
            permissionMiddleware(PERMISSIONS.INVENTORY),
          ],
        },
      },
      {
        path: "/write-off",
        name: "write-off-index",
        component: () => import("../pages/admin/write-off/index"),
        meta: {
          middleware: [
            authMiddleware,
            permissionMiddleware(PERMISSIONS["WRITE.OFF"]),
          ],
        },
      },
      // {
      //   path: "/profile",
      //   name: "user-profile",
      //   props: true,
      //   component: () => import("../pages/admin/user/profile"),
      //   meta: {
      //     middleware: authMiddleware,
      //   },
      // },
      {
        path: "/reports",
        name: "reports-index",
        component: () => import("../pages/admin/reports/index"),
        meta: {
          middleware: [
            authMiddleware,
            permissionMiddleware(PERMISSIONS.REPORTING),
          ],
        },
      },
      {
        path: "/dashboard",
        name: "dashboard-index",
        component: () => import("../pages/admin/dashboard/index"),
        meta: {
          middleware: [
            authMiddleware,
            permissionMiddleware(PERMISSIONS.DASHBOARD),
          ],
        },
      },
      {
        path: "/notification",
        name: "notification-index",
        component: () => import("../pages/admin/notification/index"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office",
        name: "my-office",
        component: () => import("../pages/admin/myoffice/index.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/product/add",
        name: "my-office-product-add",
        component: () => import("../pages/admin/myoffice/Product/add.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/product/view/:productIdView",
        name: "my-office-product-view-id",
        component: () => import("../pages/admin/myoffice/Product/view.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/product/edit/:productIdEdit",
        name: "my-office-product-edit-productId",
        component: () =>
          import("../pages/admin/myoffice/Product/edit/productIdEdit.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/department/:departmendId",
        name: "my-office-department-view",
        component: () =>
          import("../pages/admin/myoffice/Department/departmentView.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/product/:productIdView",
        name: "my-office-product-productId",
        component: () =>
          import("../pages/admin/myoffice/Product/productIdView.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
      {
        path: "/my-office/employee/:employeeIdView",
        name: "my-office-employee-view",
        component: () =>
          import("../pages/admin/myoffice/Employee/employeeView.vue"),
        meta: {
          middleware: [authMiddleware],
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  store.commit("enableAccessToView");
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }
  return next();
});

export default router;
